export const queryKeys = {
  BLACKLIST: 'BLACKLIST',
  BLACKLIST_SAME: 'BLACKLIST_SAME',
}
